import React from 'react';
import { CTAButton } from './CTAButton';
export function BeforeAfter() {
  return <section className="py-16 px-4 bg-white border-t border-gray-200" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-4">
            Antes vs Después
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-5"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-6">
          {/* Antes */}
          <div className="bg-red-50 rounded-2xl p-8 border-2 border-red-200 shadow-lg relative overflow-hidden" data-id="element-7">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-500" data-id="element-8"></div>
            <h3 className="text-3xl font-black text-red-700 mb-6 text-center" data-id="element-9">
              Antes del Reset
            </h3>
            <ul className="space-y-4 text-lg font-medium text-gray-800" data-id="element-10">
              <li className="flex items-center" data-id="element-11">
                <span className="text-red-500 mr-3 text-xl" data-id="element-12">❌</span>{' '}
                Inflamación constante
              </li>
              <li className="flex items-center" data-id="element-13">
                <span className="text-red-500 mr-3 text-xl" data-id="element-14">❌</span> Cansancio
                diario
              </li>
              <li className="flex items-center" data-id="element-15">
                <span className="text-red-500 mr-3 text-xl" data-id="element-16">❌</span> Ansiedad
                nocturna
              </li>
              <li className="flex items-center" data-id="element-17">
                <span className="text-red-500 mr-3 text-xl" data-id="element-18">❌</span> Ropa
                ajustada
              </li>
              <li className="flex items-center" data-id="element-19">
                <span className="text-red-500 mr-3 text-xl" data-id="element-20">❌</span> Empezar
                dietas cada lunes
              </li>
              <li className="flex items-center" data-id="element-21">
                <span className="text-red-500 mr-3 text-xl" data-id="element-22">❌</span> Culpa
                después de comer
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-green-50 rounded-2xl p-8 border-2 border-green-400 shadow-xl relative overflow-hidden transform md:scale-105 z-10" data-id="element-23">
            <div className="absolute top-0 left-0 w-full h-2 bg-green-500" data-id="element-24"></div>
            <h3 className="text-3xl font-black text-green-700 mb-6 text-center" data-id="element-25">
              Después de 30 días
            </h3>
            <ul className="space-y-4 text-lg font-bold text-gray-900" data-id="element-26">
              <li className="flex items-center" data-id="element-27">
                <span className="text-green-500 mr-3 text-xl" data-id="element-28">✅</span> Menos
                inflamación abdominal
              </li>
              <li className="flex items-center" data-id="element-29">
                <span className="text-green-500 mr-3 text-xl" data-id="element-30">✅</span> Más
                energía estable
              </li>
              <li className="flex items-center" data-id="element-31">
                <span className="text-green-500 mr-3 text-xl" data-id="element-32">✅</span> Mayor
                control emocional
              </li>
              <li className="flex items-center" data-id="element-33">
                <span className="text-green-500 mr-3 text-xl" data-id="element-34">✅</span> Ropa más
                suelta
              </li>
              <li className="flex items-center" data-id="element-35">
                <span className="text-green-500 mr-3 text-xl" data-id="element-36">✅</span>{' '}
                Estructura clara
              </li>
              <li className="flex items-center" data-id="element-37">
                <span className="text-green-500 mr-3 text-xl" data-id="element-38">✅</span>{' '}
                Resultados sostenibles
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-39">
          <p className="text-3xl font-black text-gray-900 mb-2" data-id="element-40">
            No es solo bajar peso.
          </p>
          <p className="text-3xl text-green-600 font-black uppercase" data-id="element-41">
            Es recuperar control.
          </p>
        </div>

        <div className="text-center" data-id="element-42">
          <CTAButton text="🔥 QUIERO TRANSFORMAR MI CUERPO EN 30 DÍAS" data-id="element-43" />
        </div>
      </div>
    </section>;
}